const home = {
  title: "GAM Command Center",
  description: "Internal project management dashboard for G.A.M",
  openDashboard: "Open Dashboard",
  workspaceName: "G.A.M — Command Center",
  workspaceLabel: "Workspace",
  devDashboard: "Development Dashboard",
  devDashboardDesc: "Projects, editor, story map, widgets",
  clientManagement: "Client Systems Management",
  clientManagementDesc: "Client portals, reports, CRM",
  adminDevLog: "Admin & Dev Log",
  adminDevLogDesc: "System status, components, version tracking",
  comingSoon: "Coming Soon",
  active: "Active",
} as const;
export default home;
